// extracted by mini-css-extract-plugin
export default {"container":"PaymentAndAgreementOptions_container__w37y8","paymentBtn":"PaymentAndAgreementOptions_paymentBtn__Jk0Rn","actionBox":"PaymentAndAgreementOptions_actionBox__CZjYY"};